<template>
  <div
    class="contact-info-view"
    v-if="!isEdit"
  >
    <table
      v-if="(currentWorkPermit.contactList || []).length"
      class="contact-view-table"
    >
      <thead>
        <tr>
          <th>
            <label class="basic-info-title contact-label-name">{{ $t('workPermit.contactInfo.contactPerson') }}</label>
          </th>
          <th>
            <label class="basic-info-title contact-label-mobile">{{ $t('workPermit.contactInfo.mobile') }}</label>
          </th>
          <th>
            <label class="basic-info-title contact-label-tel">{{ $t('workPermit.contactInfo.tel') }}</label>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in contactList "
          :key="`display-contact-info-${index}`"
        >
          <td class="content-name">
            {{ displayI18nFullName(item.firstName, item.lastName) || $t('emptyValue') }}
          </td>
          <td>{{ item.phone || $t('emptyValue') }}</td>
          <td>{{ item.tel || $t('emptyValue') }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div
    v-else
    class="contact-info-edit"
  >
    <div
      v-for="(item, index) in contactList"
      :key="`contact-list-edit-${index}`"
      class="content row"
    >
      <div class="contact-info-input small-4">
        <label
          v-if="index===0"
          class="contact-label-name required-flag"
        >
          {{ $t('workPermit.contactInfo.contactPerson') }}
        </label>
        <div class="generalInfo_contact-name name">
          <HKLInput
            v-for="fullnameObj of getFullnameSorts"
            class="small-6 columns"
            :key="`contact-name-${index}_${fullnameObj.key}`"
            :placeholder="$t(`contact.basic.${fullnameObj.label}`)"
            :value="item[`${fullnameObj.label}`]"
            v-fusioninputcheck="{type: 'string'}"
            @input="updateContact($event.target.value,fullnameObj.label, index)"
          />
        </div>
      </div>
      <div class="contact-info-input phone small-3 columns">
        <label
          v-if="index===0"
          class="contact-label-mobile required-flag"
        >
          {{ $t('workPermit.contactInfo.mobile') }}
        </label>
        <div class="mobile">
          <HKLInput
            class="generalInfo_contact-phone"
            :value="item.phone"
            @input="updateContact($event.target.value, 'phone', index)"
            v-fusioninputcheck="{type: 'string'}"
          />
        </div>
      </div>
      <div class="contact-info-input small-3 columns">
        <label
          v-if="index===0"
          class="contact-label-tel"
        >
          {{ $t('workPermit.contactInfo.tel') }}
        </label>
        <div
          class="tel-with-delete"
        >
          <HKLInput
            class="generalInfo_contact-tel"
            :value="item.tel"
            @input="updateContact($event.target.value, 'tel', index)"
          />
          <i
            v-if="contactList.length>1"
            class="fa-times fa small-1 columns"
            @click="deleteAccount(index)"
          />
        </div>
      </div>
    </div>
    <HKLButton
      id="addColumnsBtn"
      class="add-account"
      action="addContractorPerson"
      @click="addAccount"
    />
  </div>
</template>

<script>
import formFullnameMixin from '@/pages/formFullnameMixin'
import HKLInput from '@/controls/Input/HKLInput'
import { computed, unref } from '@vue/composition-api'
import lodash from 'lodash'
import { useStoreGetters, useStoreMutations } from '@/store'
import mutationTypes from '@/store/mutation-types'
import HKLButton from '../../controls/Button/HKLButton'

export default {
  components: {
    HKLInput,
    HKLButton,

  },
  mixins: [formFullnameMixin],
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  setup () {
    const initData = {
      firstName: '',
      lastName: '',
      phone: '',
      tel: '',

    }
    const { currentWorkPermit } = useStoreGetters('workPermit', ['currentWorkPermit'])
    const { updateFieldByName } = useStoreMutations('workPermit', { updateFieldByName: mutationTypes.WORKPERMIT_SET_WORKPERMIT_FIELD_BY_NAME })

    const contactList = computed(() => {
      const contacts = lodash.get(unref(currentWorkPermit), 'contactList', [])
      if (contacts.length === 0) return [initData]
      return contacts
    })

    const deleteAccount = (index) => {
      let originAccountList = lodash.cloneDeep(unref(contactList))
      originAccountList.splice(index, 1)
      updateFieldByName({ name: 'contactList', value: originAccountList })
    }

    const addAccount = () => {
      let newContact = lodash.cloneDeep(unref(contactList))
      newContact.push(unref(initData))
      updateFieldByName({ name: 'contactList', value: newContact })
    }
    const updateContact = (val, path, index) => {
      let updatedContactList = lodash.cloneDeep(unref(contactList))
      updatedContactList[index][path] = val
      updateFieldByName({ name: 'contactList', value: updatedContactList })
    }
    return {
      contactList,
      currentWorkPermit,
      updateContact,
      addAccount,
      deleteAccount,
    }
  },
}

</script>
<style lang='scss' scoped>
.name,.tel-with-delete {
  display: flex
}
.contact-info-input {
  margin-right: 10px;
  margin-top:5px;
}
.contact-info-input
.basic-info {
  margin-right: 5px
}
.add-account {
  text-decoration: underline;
  font-style: italic;
  cursor: pointer;
}
.contact-label-name,
.contact-label-mobile,
.contact-label-tel {
    margin-top: 0px;
}
.fa-times {
  cursor: pointer;
  font-size: 25px;
  padding-left:5px;
  padding-top:8px;
}
.contact-view-table {
  width: 50%;
  margin-bottom: 15px;
  .basic-info-title {
    text-transform:capitalize
  }
  .content-name {
    width: 50%
  }
}
table, thead, tbody, tr, th, td {
    margin: 0;
    padding: 0;
    border: 0;
    line-height: 1.8;
    background: transparent;
}
tbody tr:nth-child(even) {
  background-color: transparent;
}

</style>
